<div class="login-layout">
  <!-- Left column: login card -->
  <!-- <div class="login-column">
    <mat-card class="login-card">
      @if (loading()) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }
      <img class="login-logo" src="/assets/p4c-logo-black.png" alt="Privacy4Cars" />
      <mat-card-header>
        <mat-card-title>Sign in</mat-card-title>
        <mat-card-subtitle>
          @if (step() === 'credentials') {
            Access the Privacy4Cars Reporting portal
          } @else {
            Enter the 6-digit code from your authenticator
          }
        </mat-card-subtitle>
      </mat-card-header>

      <mat-card-content>
        <form [formGroup]="form" class="login-form">

          <div class="region-field">
            <span class="region-label">Server region</span>
            <mat-button-toggle-group
              formControlName="region"
              aria-label="Server region"
              [disabled]="step() === 'mfa'">
              <mat-button-toggle value="US">US</mat-button-toggle>
              <mat-button-toggle value="UK-EU">UK / EU</mat-button-toggle>
            </mat-button-toggle-group>
          </div>

          @if (step() === 'credentials') {
            <mat-form-field appearance="outline">
              <mat-label>Email ID</mat-label>
              <input matInput type="email" formControlName="email" autocomplete="username" />
              <mat-icon matSuffix>mail</mat-icon>
              @if (form.controls.email.touched && form.controls.email.invalid) {
                <mat-error>Enter a valid email address.</mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Passphrase</mat-label>
              <input matInput type="password" formControlName="password" autocomplete="current-password" />
              <mat-icon matSuffix>lock</mat-icon>
              @if (form.controls.password.touched && form.controls.password.invalid) {
                <mat-error>Passphrase is required.</mat-error>
              }
            </mat-form-field>
          } @else {
            <mat-form-field appearance="outline">
              <mat-label>MFA code</mat-label>
              <input
                matInput
                inputmode="numeric"
                maxlength="6"
                formControlName="mfaCode"
                autocomplete="one-time-code"
                placeholder="000000" />
              <mat-icon matSuffix>verified_user</mat-icon>
              @if (form.controls.mfaCode.touched && form.controls.mfaCode.invalid) {
                <mat-error>Enter the 6-digit code.</mat-error>
              }
            </mat-form-field>
          }

          @if (error()) {
            <p class="login-error">{{ error() }}</p>
          }
        </form>

        @if (step() === 'credentials') {
          <div class="demo-section">
            <button mat-button type="button" class="demo-toggle" (click)="showDemo.set(!showDemo())">
              <mat-icon>{{ showDemo() ? 'expand_less' : 'expand_more' }}</mat-icon>
              Demo accounts
            </button>
            @if (showDemo()) {
              <p class="demo-hint">Click an account to fill the form. MFA code: any 6 digits (e.g. 123456).</p>
              <div class="demo-list">
                @for (acct of demoAccounts; track acct.email) {
                  <button type="button" class="demo-account" (click)="useDemoAccount(acct)">
                    <span class="demo-account-top">
                      <span class="demo-role">{{ roleLabel(acct.role) }}</span>
                      <span class="demo-region">{{ acct.region }}</span>
                    </span>
                    <span class="demo-role-id">{{ acct.role | titlecase }}</span>
                    <span class="demo-email">{{ acct.email }}</span>
                  </button>
                }
              </div>
            }
          </div>
        }
      </mat-card-content>

      <mat-card-actions class="login-actions">
        @if (step() === 'credentials') {
          <button mat-flat-button color="primary" [disabled]="loading()" (click)="submitCredentials()">
            Sign in
          </button>
        } @else {
          <button mat-button type="button" [disabled]="loading()" (click)="backToCredentials()">
            Back
          </button>
          <button mat-flat-button color="primary" [disabled]="loading()" (click)="submitMfa()">
            Verify &amp; sign in
          </button>
        }
      </mat-card-actions>
    </mat-card>
  </div> -->

  <!-- Right column: brand panel -->
  <div class="brand-column">
    <!-- <div class="brand-content">
      <h1 class="brand-title">Privacy4Cars Reporting</h1>
      <p class="brand-subtitle">
        Business Intelligence and Usage reporting for Privacy4cars products &amp; services
      </p>
    </div> -->
    <mat-card class="login-card">
      @if (loading()) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }
      <img class="login-logo" src="/assets/p4c-logo-black.png" alt="Privacy4Cars" />
      <mat-card-header>
        <mat-card-title style="color: #000;">Reporting Portal</mat-card-title>
        <mat-card-subtitle>
<!--          @if (step() === 'credentials') {-->
            Business Intelligence and Usage Reporting
<!--          } @else {-->

<!--          }-->
        </mat-card-subtitle>
      </mat-card-header>

      <mat-card-content>
        <form [formGroup]="form" class="login-form">
         <!--  Server region
         <div class="region-field">
           <mat-button-toggle-group
             formControlName="region"
             aria-label="Server region">
             <mat-button-toggle value="US">US</mat-button-toggle>
             <mat-button-toggle value="UK-EU">UK / EU</mat-button-toggle>
           </mat-button-toggle-group>
           <span class="region-label">Server region</span>
         </div> -->

         @if (step() === 'credentials') {
            <mat-form-field appearance="outline">
              <mat-label>Email ID</mat-label>
              <input matInput type="email" formControlName="email" autocomplete="username" placeholder="Enter Email ID"/>
              <mat-icon matPrefix>mail</mat-icon>
              @if (form.controls.email.touched && form.controls.email.invalid) {
                <mat-error>Enter a valid email address.</mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Passphrase</mat-label>
              <input matInput [type]="passwordFieldType()" formControlName="password" autocomplete="current-password" placeholder="Enter Passphrase"/>
              <button mat-icon-button type="button" (click)="togglePasswordVisibility()" matSuffix>
                <mat-icon>{{passwordFieldType() == 'password' ? 'visibility_off' : 'visibility_on'}}</mat-icon>
              </button>
              <mat-icon matPrefix>lock</mat-icon>
              @if (form.controls.password.touched && form.controls.password.invalid) {
                <mat-error>Passphrase is required.</mat-error>
              }
            </mat-form-field>
         }
         @else {
           <mat-form-field appearance="outline">
             <mat-label>MFA code</mat-label>
             <input
               matInput
               inputmode="numeric"
               maxlength="6"
               formControlName="mfaCode"
               autocomplete="one-time-code"
               placeholder="000000" />
             <mat-icon matPrefix>verified_user</mat-icon>
             @if (form.controls.mfaCode.touched && form.controls.mfaCode.invalid) {
               <mat-error>Invalid Code</mat-error>
             } @else {
               <mat-hint style="color: #000;">Enter the 6-digit MFA code</mat-hint>
             }
           </mat-form-field>
         }
        </form>
      </mat-card-content>

      <mat-card-actions class="login-actions">
       @if (step() === 'credentials') {
          <button mat-button type="button" (click)="forgotPassword()">Forgot Passphrase</button>
          <button mat-flat-button color="primary" [disabled]="loading()" (click)="submitCredentials()">
            Send OTP
          </button>
       }
       @if (step() === 'mfa')  {
         <button mat-button type="button" [disabled]="loading()" (click)="backToCredentials()">
           Back
         </button>
         <button mat-raised-button [disabled]="loading()" (click)="resendOTP()">Resend Code</button>
         <button mat-flat-button color="primary" [disabled]="loading()" (click)="submitMFA()">
           Verify &amp; Sign in
         </button>
       }
      </mat-card-actions>

     <!-- @if (step() === 'credentials') {
       <div class="demo-section">
         <button mat-button type="button" class="demo-toggle" (click)="showDemo.set(!showDemo())">
           <mat-icon>{{ showDemo() ? 'expand_less' : 'expand_more' }}</mat-icon>
           Demo accounts
         </button>
         @if (showDemo()) {
           <p class="demo-hint">Click an account to fill the form. MFA code: any 6 digits (e.g. 123456).</p>
           <div class="demo-list">
             @for (acct of demoAccounts; track acct.email) {
               <button type="button" class="demo-account" (click)="useDemoAccount(acct)">
                 <span class="demo-account-top">
                   <span class="demo-role">{{ roleLabel(acct.role) }}</span>
                   <span class="demo-region">{{ acct.region }}</span>
                 </span>
                 <span class="demo-role-id">{{ acct.role | titlecase }}</span>
                 <span class="demo-email">{{ acct.email }}</span>
               </button>
             }
           </div>
         }
       </div>
     } -->

    </mat-card>

    <mat-card class="login-card help-card">

      <mat-card-header>
        <mat-card-title>Need help?</mat-card-title>
        <mat-card-subtitle>Reach out to us at:</mat-card-subtitle>
      </mat-card-header>

      <mat-card-actions class="help-cta">
        <!-- <div>
          <span>Need help? <br></span>
          <span>Reach out to us at:</span>
        </div> -->
        <button mat-raised-button color="primary" (click)="copyEmail()">
          <span>support&#64;privacy4cars.com</span>
          <mat-icon iconPositionEnd>content_copy</mat-icon>
        </button>
      </mat-card-actions>

    </mat-card>

  </div>
</div>
